export const ListPaginationConfig = {
	headers: { Accept: 'application/vnd.api+json' },
};
